import {
  DEFAULT_AUTHOR_NAME,
  SITE_NAME,
  buildCanonicalUrl,
} from "@/config/siteSeo";

export const buildBreadcrumbSchema = (items: { name: string; path: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: buildCanonicalUrl(item.path),
  })),
});

export const buildCollectionPageSchema = ({
  title,
  path,
  description,
}: {
  title: string;
  path: string;
  description: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: title,
  url: buildCanonicalUrl(path),
  description,
  isPartOf: {
    "@type": "WebSite",
    name: SITE_NAME,
    url: buildCanonicalUrl("/"),
  },
});

export const buildBlogPostingSchema = ({
  title,
  path,
  description,
  datePublished,
  dateModified,
  keywords,
}: {
  title: string;
  path: string;
  description: string;
  datePublished: string;
  dateModified?: string;
  keywords?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: title,
  description,
  datePublished,
  dateModified: dateModified || datePublished,
  author: {
    "@type": "Person",
    name: DEFAULT_AUTHOR_NAME,
  },
  publisher: {
    "@type": "Organization",
    name: SITE_NAME,
  },
  mainEntityOfPage: buildCanonicalUrl(path),
  keywords,
});
